module.exports = __webpack_public_path__ + "img/ht_icon_calendar_line.1cc0e253.svg";